// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 152 ? "about" : chunkId) + "." + {"44":"42d29394","152":"2c88f3b6","392":"2a52749e","464":"e8a82c59","576":"d44a2311","660":"0e695823","780":"23dc49e6","892":"8d49cfa6"}[chunkId] + ".js";
};